import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/accelerated-tms-verify-provider")({
  beforeLoad: () => {
    throw redirect({ to: "/find-a-verified-saint-provider" });
  },
});
